module.exports = __webpack_public_path__ + "img/ico_video.97592127.svg";